// extracted by mini-css-extract-plugin
module.exports = {"backLink":"BackLink__backLink___1MOmT","backLink__arrow":"BackLink__backLink__arrow___1yOYT","backLink__title":"BackLink__backLink__title___14VTT"};